import { replaceStringFromObject, truncateString } from "../utils/utils";
import moment from "moment";

const request = (obj) => {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    xhr.open(obj.method || "GET", obj.url);
    if (obj.withCredentials) {
      xhr.withCredentials = obj.withCredentials;
    }
    if (obj.responseType) {
      xhr.responseType = obj.responseType;
    } else {
      xhr.responseType = "json";
    }
    if (obj.headers) {
      // xhr.setRequestHeader("X-PINGOTHER", "pingpong");
      Object.keys(obj.headers).forEach((key) => {
        xhr.setRequestHeader(key, obj.headers[key]);
      });
    }
    const errorObj = { ...obj.error, status: xhr.statusText };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(xhr.response);
      } else if (xhr.status === 400 && xhr.response.message) {
        reject(xhr.response);
      } else {
        reject(errorObj);
      }
    };
    xhr.onerror = () => reject(errorObj);
    if (obj.body) {
      xhr.send(obj.body);
    } else {
      xhr.send();
    }
  });
};

export const verifyCaptchaService = async (token, recaptcha) => {
  const dataRequest = {
    url: recaptcha.apiUrl,
    method: "POST",
    body: "response=" + token + "&form_key=" + recaptcha.formKey,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    responseType: "json",
    error: {
      message: "Recaptcha Error",
      captchaError: true,
    },
  };
  return request(dataRequest);
};

export const verifyUtillityAccountService = (
  accountData,
  verifyUtilityAccount,
  addressBarcode,
  formBehaviors,
  productInfo,
  errorMessage,
  baseUrl
) => {
  const params = {
    ...accountData,
    context: { value: verifyUtilityAccount.context },
  };
  if (addressBarcode) {
    params.barcode = { value: addressBarcode };
  }
  if (formBehaviors) {
    params.disable_ccv = { value: formBehaviors?.disable_ccv_service };
  }
  if (productInfo) {
    params.incentive_type = { value: productInfo?.productIncentiveType };
  }
  let urlParams = [];

  Object.keys(params).forEach(function (key) {
    if(typeof params[key] === "object") {
      params[key]['value'] = key === "zip" ? truncateString(params[key].value, 5) : params[key].value;
      urlParams.push(key + "=" + encodeURIComponent(params[key].value));
      if (key === "lastName") {
        urlParams.push("last_name=" + encodeURIComponent(params[key].value));
      }
    }
    else{
      urlParams.push(key + "=" + encodeURIComponent(params[key]));
    }
  });
  
  let headers = {};
  verifyUtilityAccount.headers.forEach((header) => {
    headers[header.key] = header.value;
  });

  const data = {
    // eslint-disable-next-line
    url: `${baseUrl}rest/V1/cr/services/ccv/validation` + "?" + urlParams.join("&"),
    method: "GET",
    headers,
    withCredentials: true,
    error: {
      message: errorMessage,
    },
  };
  return request(data);
};

export const receiptSavingService = (
  formData,
  baseUrl,
  errorMessage,
  measureId,
  productId,
  accountState
) => {
  let urlParams = [];
  const formatDateForService = "YYYY-MM-DD";
  formData.forEach(function (answer) {
    let paramValue = answer.textValue;
    if (answer.type === "date") {
      paramValue = moment(answer.value).format(formatDateForService);
    }
    if (answer.multiple) {
      paramValue = answer.value.join(",");
    }
    if (answer.maskType === "money") {
      paramValue = answer.value;
    }
    if (answer.id === "ahri_number" && (answer.textValue === "" || answer.textValue === undefined || answer.textValue === null)  ) {
      paramValue = "null";
    }
    urlParams.push(answer.name + "=" + encodeURIComponent(paramValue));
  });
  //TECH DEBT: to get this value from a source
  urlParams.push("retailer_composite=x");


  let quantityIndex = urlParams.findIndex((param) => { return param.startsWith("quantity=") && !param.endsWith("=");})

  if(quantityIndex < 0 && accountState?.productInfo?.cr_incentive_count) {

    if(urlParams.indexOf("quantity=") >= 0) {
      urlParams.splice(urlParams.indexOf("quantity="), 1)
    }
    
    urlParams.push(`quantity=${accountState.productInfo.cr_incentive_count}`)
  
    //filter question object because answers object does not contain field fieldReference
    Object.values(accountState.questions).filter(questionObj => { 
      questionObj.forEach(question => {
        
        if(question.id === "quantity"){
          let quantityAnswerField =  accountState?.answers?.[question.group].find(ans => ans.id === question.id);
          quantityAnswerField.value = accountState?.productInfo?.cr_incentive_count
          quantityAnswerField.textValue =   accountState?.productInfo?.cr_incentive_count
        } 

        if(question?.fieldReference) {
          const [ group, fieldId ] = question.fieldReference.split(".");

          //finding reference field from answers because question field does not contain value
          const referenceField =  accountState?.answers?.[group].find(ans => ans.id === fieldId && ans.value !== "");
          
          //finding measureInputAnswerField with question?.fieldReference reference to update 
          //their answerObject which will measureInput[] too. Later it will be used for power BI calculation
          
          const measureInputAnswerField =  accountState?.answers?.[question.group].find(ans => ans.id === question.id );
          updateMeasureInputAnswerField(measureInputAnswerField, referenceField)

          if(urlParams.indexOf(`${question.name}=`) >= 0) {
            urlParams.splice(urlParams.indexOf(`${question.name}=`), 1)
          }
          urlParams.push(`${question.name}=${referenceField.value}`)
        }
      })
    })
  }
 
  const requestUrl = `${baseUrl}rest/V1/cr/pimcore/savings/{measureId}/product/{productId}`;
  console.log("requestUrl", requestUrl);
  const data = {
    url: replaceStringFromObject(requestUrl, { measureId, productId }) + "?" + urlParams.join("&"),
    method: "GET",
    withCredentials: true,
    error: {
      message: errorMessage,
    },
  };
  return request(data);
};

const updateMeasureInputAnswerField= (answerField, referenceField) => {
  answerField.value = referenceField.value;
  answerField.textValue = referenceField.textValue;
  answerField.extraValues = referenceField.extraValues;
}

const measureInfoServiceCall = (
  urlParams,
  baseUrl,
  errorMessage,
  pimcore
) => {
  const data = {
    url: ` ${baseUrl}rest/V1/cr/pimcore/measure/info/${pimcore.measureId}?${urlParams.join("&")}`,
    method: "GET",
    withCredentials: true,
    responseType: "json",
    error: {
      message: errorMessage,
    },
  };
  return request(data);
};

export const getMakes = (
  baseUrl,
  errorMessage,
  pimcore) => {
  let urlParams = ["models=no"];
  return measureInfoServiceCall(
    urlParams,
    baseUrl,
    errorMessage,
    pimcore
  )
}

export const getModels = (
  baseUrl,
  errorMessage,
  pimcore, make) => {
  let urlParams = ["make=" + encodeURIComponent(make), "models=yes"];
  return measureInfoServiceCall(
    urlParams,
    baseUrl,
    errorMessage,
    pimcore
  )
}

export const AHRIInfoServiceCall = (baseUrl, AHRI_ID, categoryLabel, errorMessage) => {
  let formData = new FormData();
  let query = `[{"field":"pd_id","comparison":"=","value":"${AHRI_ID}"}${(categoryLabel) ?
    `,{"field":"dataset","comparison":"=","value":"${categoryLabel}"}` : ''}]`;

  formData.append("q", query);

  const data = {
    url: `${baseUrl}rest/V1/cr/pimcore/ahri/search`,
    method: "POST",
    withCredentials: true,
    responseType: "json",
    body: formData,
    error: {
      message: errorMessage,
    },
  };
  return request(data);
}

export const getContractorDetailsService = (baseUrl, contractorName) => {
  const data = {
    url: `${baseUrl}rest/V1/cr/trade-ally/contractor/autocomplete?company_name=${contractorName}&distinct=1`,
    method: "GET",
  };
  return request(data);
}

// Customer upload files
const getBase64 = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(file);
  })
}

export const customerUploadFiles = async (baseUrl, customer, file, onProgress) => {
  const resData = await getBase64(file);
  const url = `${baseUrl}rest/V1/cr/eligibility-wizard/mine/document`;
  const body = {
    "base64": resData,
    "customerId": customer.id,
    "name": file.name
  }
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    let jsonResponse = null;
    xhr.open("POST", url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Authorization', 'Bearer ' + customer.token);
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        jsonResponse = JSON.parse(xhr.response);
        resolve(jsonResponse);
      } else if (xhr.status === 500) {
        onProgress(Math.round(100));
        resolve(xhr.response);
      } else {
        reject(xhr.statusText);
      }
    };
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentage = (event.total / event.loaded) * 100;
        onProgress(Math.round(percentage));
      }
    };
    xhr.send(JSON.stringify(body));
    return jsonResponse;
  });
}

// Customer delete files
export const customerDeleteFiles = async (baseUrl, customer, file) => {
  const dataRequest = {
    url: `${baseUrl}rest/V1/cr/eligibility-wizard/mine/document/${customer.id}/${file.name}`,
    method: "DELETE",
    contentType: 'application/json',
    headers: {
      "Authorization": `Bearer ${customer.token}`
    },
  };
  return request(dataRequest);
}

// Get skedulo available days
export const getAvailableDays = async (baseUrl, customer, availabilityResponse) => {
  const dataRequest = {
    url: `${baseUrl}rest/V1/cr/skedulo/available_days/`,
    method: 'POST',
    contentType: 'application/json',
    headers: {
      "Authorization": `Bearer ${customer.token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(availabilityResponse)
  };
  return request(dataRequest);
}

// Get Skedulo region Id
export const getRegionId = async (baseUrl, customer, zipCode) => {
  const dataRequest = {
    url: `${baseUrl}rest/V1/cr/skedulo/region/${zipCode}`,
    method: 'GET',
    contentType: 'application/json',
    headers: {
      "Authorization": `Bearer ${customer.token}`
    },
  };
  return request(dataRequest);
};

// Get Skedulo job duration
export const getJobTemplateData = async (baseUrl, customer, programName, productType, sqft, largeHomeSqft, largeHomeDuration) => {
  const bodyRequest = {
    "appointmentTemplate": {
      "job_type": `${productType}`,
      "program_name": `${programName}`,
      "sqft": `${sqft}`,
      "large_home_sqft": `${largeHomeSqft}`,
      "large_home_duration": `${largeHomeDuration}`
    }
  }
  const dataRequest = {
    url: `${baseUrl}rest/V1/cr/skedulo/templates`,
    method: 'POST',
    headers: {
      "Authorization": `Bearer ${customer.token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(bodyRequest)
  };
  return request(dataRequest);
};

// Get skedulo available resources
export const getAvailability = async (baseUrl, customer, availableResources) => {
  const dataRequest = {
    url: `${baseUrl}rest/V1/cr/skedulo/available_schedules/`,
    method: 'POST',
    headers: {
      "Authorization": `Bearer ${customer.token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(availableResources)
  };
  return request(dataRequest);
};

// Create skedulo job
export const createSkeduloJob = async (baseUrl, customer, bodyData) => {
  const dataRequest = {
    url: `${baseUrl}rest/V1/cr/skedulo/job/`,
    method: 'POST',
    headers: {
      "Authorization": `Bearer ${customer.token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(bodyData)
  };
  return request(dataRequest);
};

// Delete skedulo job
export const deleteSkeduloJob = async (baseUrl, customer, jobId, reasonValue, comment) => {
  const bodyCancelRequest = {
    "cancelJob": {
      "cancelReason": `${reasonValue}`,
      "comment": `${comment}`
    }
  }
  const dataRequest = {
    url: `${baseUrl}rest/V1/cr/skedulo/job/${jobId}`,
    method: 'PUT',
    headers: {
      "Authorization": `Bearer ${customer.token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(bodyCancelRequest)
  };
  return request(dataRequest);
};

// Reschedule skedulo job
export const rescheduleSkeduloJob = async (baseUrl, customer, bodyData) => {
  const dataRequest = {
    url: `${baseUrl}rest/V1/cr/skedulo/job/`,
    method: 'PUT',
    headers: {
      "Authorization": `Bearer ${customer.token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify(bodyData)
  };

  return request(dataRequest)
};

// Address suggestion service
export const addressSuggestionService = (baseUrl, value) => {
  const selected = value.includes("entries")
      ? value.replace(" entries", "")
      : "";
  const dataRequest = {
      url: `${baseUrl}rest/V1/cr/smartystreets/autocomplete?search=${encodeURIComponent(value)}&selected=${encodeURIComponent(selected)}`,
      method: "GET",
      contentType: "application/json",
  };
  return request(dataRequest);
};

// Address selection service
export const addressSelectionService = (baseUrl, completeAddress) => {
  const unitValue = encodeURIComponent(completeAddress.unit.value);
  const street = encodeURIComponent(completeAddress.address.value);
  const city = encodeURIComponent(completeAddress.city.value);
  const state = encodeURIComponent(completeAddress.state.value);
  const street2 = unitValue !== ""
    ? `street2=${unitValue}&`
    : "";
  const dataRequest = {
    url: `${baseUrl}rest/V1/cr/smartystreets/street-address?street=${street}&${street2}city=${city}&state=${state}`,
    method: 'GET',
    contentType: 'application/json',
  };
  return request(dataRequest);
}
